import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const options = [
  {
    value: 'opname',
    label: 'Opname',
  },
  {
    value: 'adjustment',
    label: 'Adjustment',
  },
];

const initialState = {
  type: '',
  _type: null,
  note: '',
};

export const FormInput = ({ data, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ type, note, _type }, setState] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleType = async (e) => {
    setState((prevState) => ({
      ...prevState,
      _type: e,
      type: e?.value,
    }));
  };

  React.useEffect(() => {
    const input = {
      type,
      note,
    };

    onInputChange(input);
  }, [type, note]);

  React.useEffect(() => {
    if (!data) return;

    const t =
      data?.type === 'opname'
        ? options[0]
        : data?.type === 'adjustment'
        ? options[1]
        : null;

    setState((prevState) => ({
      ...prevState,
      _type: t,
      type: t?.value,
      note: data?.note,
    }));
  }, [data]);

  return (
    <div className="mt-3 ">
      <div className="py-3 px-2 px-md-2 pe-md-4">
        {loading ? (
          <div className="row ">
            {dummy?.map((d, i) => (
              <div className="col-md-4" key={i}>
                <SkeletonsForm count={1} />
              </div>
            ))}
          </div>
        ) : (
          <div className="">
            <div className="mb-3">
              <label className="form-label required">Pilih Tipe</label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.type ? 'is-invalid' : 'select'
                }
                placeholder=""
                options={options}
                value={_type}
                onChange={$handleType}
                error={StateForm?.errors?.type}
              />
              {StateForm?.errors?.type ? (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.type}
                </div>
              ) : null}
            </div>
            <Form.Textbox
              label="Catatan"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </div>
        )}
      </div>
    </div>
  );
};
